import { useEffect, useState } from 'react';

import { IProdutoDafRegistro } from '../../modules/types/ProdutoDaf';
import { getAllProdutos } from '../produtosDAF/produtosDafService';

let produtosDafCache: IProdutoDafRegistro[] | null = null;

export function getProdutosDafMemoryCache() {
  return produtosDafCache;
}

export function setProdutosDafMemoryCache(data: IProdutoDafRegistro[]) {
  produtosDafCache = data;
}

export function clearProdutosDafMemoryCache() {
  produtosDafCache = null;
}

export function useProdutosDafCache() {
  const [data, setData] = useState<IProdutoDafRegistro[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getProdutosDafMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllProdutos()
      .then((result) => {
        setData(result);
        setProdutosDafMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
